import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';
import cx from '@/utils/cx';

const LayoutContext = createContext(null);

const Layout = ({
  children,
  className,
  height,
  onScrollEnd,
  ...rest
}) => {
  const classes = useStyle({ height });
  const { Provider } = LayoutContext;

  const [scrollTop, setScrollTop] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(null);
  const [layoutHeight, setHeight] = useState(null);
  const [lastCall, setLastCall] = useState(0);
  const [lastScrollEndCall, setLastScrollEndCall] = useState(-1);
  const handleScroll = (e) => {
    if (e.target.className.indexOf('layout-') === -1) return;
    const now = Date.now();
    const top = e.target.scrollTop;
    const max = e.target.scrollHeight - e.target.offsetHeight;
    if (top < 3 || now > (lastCall + 10)) {
      setScrollTop(top);
      setScrollHeight(e.target.scrollHeight);
      setHeight(e.target.offsetHeight);
      setLastCall(now);
      if (top >= max - 20 && lastScrollEndCall !== max) {
        setLastScrollEndCall(max);
        onScrollEnd(top);
      }
    }
  };

  return (
    <Provider value={{ scrollTop, scrollHeight, layoutHeight }}>
      <div
        className={cx(classes.layout, className)}
        onScroll={handleScroll}
        {...rest}
      >
        {children}
      </div>
    </Provider>
  );
};

Layout.propTypes = {
  height: PropTypes.string,
  onScrollEnd: PropTypes.func,
};

Layout.defaultProps = {
  height: '100%',
  onScrollEnd: () => {},
};

export { Layout, LayoutContext };
export default Layout;
